import React, {useState} from 'react';
import MaterialTable from 'material-table';
import format from 'date-fns/format';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogContentText from '@material-ui/core/DialogContentText';
import {IItem} from './Kms';

const {tableIcons} = require('../muiConsts/tableIcons');

export default ({
  rows,
  refresh,
  isLoading,
  setEditObject,
}: {
  rows: IItem[];
  refresh: () => void;
  isLoading: boolean;
  setEditObject: (item: IItem) => void;
}) => {
  const [appData, openConfirmDialog] = useState({open: false, row: {}});

  const columns: any = [
    {
      title: 'Name',
      field: 'name',
      lookup: rows.reduce((curr: {[index: string]: string}, row) => {
        curr[row.name] = row.name;
        return curr;
      }, {}),
    },
    {
      title: 'Type',
      field: 'type',
      lookup: rows.reduce((curr: {[index: string]: string}, row) => {
        curr[row.type] = row.type;
        return curr;
      }, {}),
    },
    {
      title: 'Expires',
      field: 'expire',
      filtering: false,
      render: ({expire}: any) => format(new Date(expire / 0.001), 'EEEE MMM d yyyy HH:mm'),
    }, // Wed Dec 31 1969
    {
      title: 'Data',
      width: '40%',
      field: 'data',
      filtering: false,
      render: ({data}: any) => JSON.stringify(data, null, 2),
      sorting: false,
    },
  ];
  return (
    <>
      <MaterialTable
        actions={[
          {
            icon: () => <Edit />,
            tooltip: 'Edit Key',
            onClick: (_, rowData: any) => {
              setEditObject(rowData);
            },
          },
          {
            icon: () => <DeleteOutline />,
            tooltip: 'Delete Key',
            onClick: (_, rowData: any) => openConfirmDialog({open: true, row: rowData}),
          },
        ]}
        columns={columns}
        data={rows}
        icons={tableIcons}
        isLoading={isLoading}
        options={{
          actionsColumnIndex: -1,
          emptyRowsWhenPaging: false,
          filtering: true,
          search: false,
          showTitle: false,
          toolbar: false,
        }}
      />
      <Dialog open={appData.open}>
        <DialogTitle id="form-dialog-title">Delete File</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this file?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => openConfirmDialog({open: false, row: {}})}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (appData.row.name) {
                fetch(`/api/kms/v1/management/${appData.row.name}`, {method: 'DELETE'}).then(() => refresh());
              }
              openConfirmDialog({open: false, row: {}});
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
